import request from '@/router/axios';

export const startList = (current, size, params) => {
  return request({
    url: '/api/blade-flow/work/start-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const claimList = (current, size, params) => {
  return request({
    url: '/api/blade-flow/work/claim-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const todoList = (current, size, params) => {
  return request({
    url: '/api/blade-flow/work/todo-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const sendList = (current, size, params) => {
  return request({
    url: '/api/blade-flow/work/send-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}


export const doneList = (current, size, params) => {
  return request({
    url: '/api/blade-flow/work/done-list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const claimTask = (taskId) => {
  return request({
    url: '/api/blade-flow/work/claim-task',
    method: 'post',
    params: {
      taskId
    }
  })
}


export const completeTask = (data) => {
  return request({
    url: '/api/blade-flow/work/complete-task',
    method: 'post',
    data
  })
}

export const rollback = (taskId) => {
  return request({
    url: '/api/blade-flow/work/rollback',
    method: 'post',
    params: {
      taskId
    }
  })
}

export const completeTaskBatch = (data) => {
  return request({
    url: '/api/blade-flow/work/complete-task-batch',
    method: 'post',
    data
  })
}